<div class="auth-container">
  <div class="content">
    <div class="form-container">
      <div class="form-header">
        <img src="/assets/images/logo.png" class="form-logo" alt="logo" />
        <div class="title-wrapper">
          <h1 class="form-title">Forgot password?</h1>
          <p class="form-desc">
            No worries, we'll send you reset instructions.
          </p>
        </div>
        <div *ngIf="errorMessage" class="invalid">
          <svg-icon
            src="/assets/icon/icon-info.svg"
            class="icon s-12"></svg-icon>
          <p class="text">{{ errorMessage }}</p>
        </div>
      </div>

      <form
        nz-form
        [formGroup]="forgotPasswordForm"
        class="form"
        nzLayout="vertical"
        (ngSubmit)="submitForm()">
        <nz-form-item>
          <nz-form-label nzFor="email" nzRequired>Username</nz-form-label>
          <nz-form-control [nzErrorTip]="emailErrorTpl">
            <nz-input-group [nzSuffix]="suffixTemplateInfo">
              <div class="input-wrapper">
                <input
                  name="email"
                  type="email"
                  nz-input
                  id="email"
                  formControlName="email"
                  placeholder="Enter username" />
              </div>
            </nz-input-group>
          </nz-form-control>
        </nz-form-item>

        <button
          nz-button
          [nzBlock]="true"
          class="form-button"
          [disabled]="forgotPasswordForm.invalid || isLoading"
          [nzType]="'primary'"
          [nzLoading]="isLoading"
          type="submit">
          Reset password
        </button>
      </form>

      <a class="back-link" routerLink="/login">
        <svg-icon
          src="/assets/icon/icon-arrow.svg"
          class="icon s-12"></svg-icon>
        Back to sign in
      </a>
    </div>
  </div>
</div>

<ng-template #suffixTemplateInfo>
  <i
    nz-icon
    nzType="info-circle"
    nz-tooltip
    nzTooltipTitle="Your username is your email address"></i>
</ng-template>

<ng-template #emailErrorTpl let-control>
  <ng-container *ngIf="control.hasError('required')">
    Please enter your username.
  </ng-container>
  <ng-container
    *ngIf="control.hasError('email') || control.hasError('pattern')">
    Please enter a valid username.
  </ng-container>
</ng-template>
